import { FC } from "react";

import Stack from "@mui/material/Stack";

import { DashboardHighlightedText } from "@/dashboard-design-system/HighlightedText";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";
import { useQuickSearchContext } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/QuickSearch";

interface TicketingIdleSummaryProps {
  title: string;
}

export const TicketingIdleSummary: FC<TicketingIdleSummaryProps> = ({ title }) => {
  const { query } = useQuickSearchContext();

  return (
    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ minWidth: 0, flex: 1 }}>
      <DashboardTypography
        variant="subtitle1"
        sx={(theme) => ({
          color: theme.palette.text.neutral.moderate,
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        })}
      >
        <DashboardHighlightedText text={title} query={query} />
      </DashboardTypography>
    </Stack>
  );
};
